<template>
  <div class="backdrop" @click="closeModal">
    <div class="content half" v-if="props.mode">
      <close-button
        class="closebtn"
        mode="small"
        @click="closeBtn"
      ></close-button>

      <slot> </slot>
    </div>
    <div class="content oneFourth" v-else>
      <close-button
        class="closebtn"
        mode="small"
        @click="closeBtn"
      ></close-button>

      <slot> </slot>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import CloseButton from "../buttons/CloseButton.vue";

// const store = useStore();
const props = defineProps(["mode"]);

const emits = defineEmits(["toggleVisibility"]);

function closeModal(e) {
  e.preventDefault();
  if (e.target.className === "backdrop") return emits("toggleVisibility");
}

function closeBtn() {
  emits("toggleVisibility");
}
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;

  z-index: 5000;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.content {
  position: relative;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.closebtn {
  position: absolute;
  top: 2rem;
  right: 2rem;
}

.half {
  /* margin-top: -10rem; */
  margin-right: 5vw;
  background-color: #cfe6b2;

  width: 50vw;
  height: auto;
  border-radius: 5px;

  /* height: 45vw; */
}
/* 1160px*/
@media only screen and (max-width: 72.5em) {
  .half {
    width: 60vw;
  }
}
/* 1024px*/
@media only screen and (max-width: 64em) {
  .half {
    width: 75vw;
    padding: 0.5vw;
  }
}
/* 860px*/
@media only screen and (max-width: 53.75em) {
  .half {
    width: 80vw;
  }
}
/* 768px 48*/

@media only screen and (max-width: 48em) {
  .half {
    margin: 0 auto;
    width: 90vw;
  }
}

/* 570px*/
@media only screen and (max-width: 42em) {
  .half {
    /* width: 100vw;
    height: 100vh; */
    overflow-y: auto;
    height: 90vh;
  }
}

.oneFourth {
  margin-right: 15vw;
  width: 25vw;
  height: 25vw;
  border-radius: 20px;
  background-color: #cfe6b2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
/* 1024px*/
@media only screen and (max-width: 64em) {
  .oneFourth {
    margin-right: 10vw;
    width: 35vw;
    height: 35vw;
  }
}
/* 768px*/
@media only screen and (max-width: 48em) {
  .oneFourth {
    margin-right: 5vw;
    width: 50vw;
    height: 50vw;
  }
}
/* 600px */

@media only screen and (max-width: 37.5em) {
  .oneFourth {
    margin-left: auto;
    margin-right: auto;
    width: 70vw;
    height: 70vw;
  }
}

/* 425px */

@media only screen and (max-width: 26.5em) {
  .oneFourth {
    width: 80vw;
    height: 80vw;
  }
}

.error {
  background-color: var(--color-primary-1);
  /* background-image: linear-gradient(to bottom, var(--color-primary-5), var(--color-grey-3)); */
  width: 50%;
  height: 50%;
}
@media only screen and (max-width: 64em) {
  .error {
    width: 75%;
  }
}
.false {
  background-color: red;
}
.true {
  background-color: green;
}
</style>
